import React from 'react';

// Renderse lockscreen
class LockScreen extends React.Component {
    render() {
        return (
            <div>
                <div className="lock-display">
                    
                </div>
                <div className="bottom-div-lock">
                    <h3>Press Centre Button to Menu!</h3>
                </div>
            </div>
        )
    }

}


export default LockScreen;